import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router/index'
import Vconsole from 'vconsole'
// @ts-ignore
import vueEsign from 'vue-esign'
import '@/assets/style/reset.scss'
// Core 公共能力
import vantPlugins from '@core/plugins/vant'
import { useUserStore } from '@core/stores/user'
import { createAppPinia } from '@core/plugins/pinia'
import { setAppHeightVar } from '@core/utils/app-height'
import { registerLangPack } from '@core/langs'
import { initLanguage } from '@core/composables/useLanguage'
import en from './i18n/langs/en'
import zn from './i18n/langs/zn'
import { vantUse } from './i18n'
import { getHeaderData, getUserData } from '@core/utils/nativeAPI'

// 注册语言包
registerLangPack('en', en)
registerLangPack('cn', zn)

setAppHeightVar()

const app = createApp(App)
const pinia = createAppPinia()

app.use(pinia)
app.use(vantPlugins)
// @ts-ignore
app.use(vueEsign)
app.use(router)
getUserData()
getHeaderData()
const userStore = useUserStore()
if (userStore.header?.language) {
  localStorage.setItem('language', userStore.header.language.toLowerCase())
}
// 定义本业务支持的语言选项
const LANG_OPTIONS = [
  { name: 'EN', key: 'en' },
  { name: 'CN', key: 'cn' }
]

initLanguage('en', ['en', 'cn'], userStore, LANG_OPTIONS)
vantUse(userStore.header?.language || 'en')
app.mount('#app')
import.meta.env.VITE_APP_ENV != 'prod' && new Vconsole()
